import axios from '@/lib/AxApi';

export default
{
    async getGroups(params)
    {
        try
        {
            const response = await axios.get('/AclPrivilages/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async getPrivilagesByGroupId(params)
    {
        try
        {
            const response = await axios.get('/AclPrivilages/getPrivilagesByGroupId',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async updatePrivilageByGroupId(params)
    {
        try
        {
            const response = await axios.post('/AclPrivilages/updatePrivilageByGroupId', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async saveAcl(params)
    {
        try
        {
            const response = await axios.post('/AclObjects/insertRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteAcl(params)
    {
        try
        {
            const response = await axios.post('/AclObjects/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
